module.exports = __webpack_public_path__ + "img/LOGIN_CLASSICO_PORTAL.e91df2be.png";